import React, { useState, useEffect } from 'react';
import { Modal, Input, Select, Button } from './ui';

interface TokenModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (tokenData: { name: string; expiresIn: string; scopes: string[] }) => Promise<void>;
}

export default function TokenModal({ isOpen, onClose, onSave }: TokenModalProps) {
  const [formData, setFormData] = useState({
    name: '',
    expiresIn: '30d',
  });

  useEffect(() => {
    if (!isOpen) {
      // Reset form when modal closes
      setFormData({
        name: '',
        expiresIn: '30d',
      });
    }
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!formData.name.trim()) {
      alert('Please enter a token name');
      return;
    }

    await onSave({
      name: formData.name.trim(),
      expiresIn: formData.expiresIn,
      scopes: [], // Not used anymore but keep interface compatible
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header onClose={onClose}>
        <h3>Create API Token</h3>
      </Modal.Header>
      <Modal.Body>
        <Input
          id="tokenName"
          label="Token Name"
          value={formData.name}
          onChange={e => setFormData({ ...formData, name: e.target.value })}
          placeholder="e.g., MCP Server, CLI Tool, Production Deploy"
          hint="Choose a descriptive name to identify this token later"
          required
        />

        <Select
          id="expiresIn"
          label="Expiration"
          value={formData.expiresIn}
          onChange={e => setFormData({ ...formData, expiresIn: e.target.value })}
          hint="Tokens have full access to all API endpoints"
          required
        >
          <option value="7d">7 days</option>
          <option value="30d">30 days (recommended)</option>
          <option value="90d">90 days</option>
          <option value="1y">1 year</option>
          <option value="never">Never expire</option>
        </Select>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" icon="fa-solid fa-key" onClick={handleSubmit}>
          Create Token
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
